import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "design_system_radar/tooltip";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";

import { routes } from "@/config/routing/routes";
import { PENDING_REVIEW_BADGE_CAP } from "@/hooks/usePendingReviewUploads";

interface PendingReviewIndicatorProps {
  count: number;
  expanded: boolean;
}

// Pending-review indicator anchored to the "Datos" sidebar item: an eye icon +
// count with a tooltip spelling out the action. Fixed white fill + dark text so
// it reads on any sidebar color across environments. Clicking it deep-links to
// the upload history. Hidden when there is nothing to review.
export function PendingReviewIndicator({
  count,
  expanded,
}: PendingReviewIndicatorProps) {
  if (count <= 0) return null;

  const display =
    count > PENDING_REVIEW_BADGE_CAP
      ? `${PENDING_REVIEW_BADGE_CAP}+`
      : `${count}`;
  const label = `Tienes ${display} ${
    count === 1 ? "carga de archivo pendiente" : "cargas de archivos pendientes"
  } de revisar`;
  const historyHref = `${routes.data_v2.absolute}?view=history`;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to={historyHref}
          aria-label={label}
          className={
            expanded
              ? "pending-review-pulse -translate-y-1/2 absolute top-1/2 right-1 z-10 flex items-center gap-1 rounded-md bg-white px-1.5 py-0.5 font-semibold text-slate-900 text-xs tabular-nums shadow-sm transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
              : "pending-review-pulse absolute top-0 right-0 z-10 flex h-4 min-w-4 items-center justify-center rounded-md bg-white px-1 font-semibold text-[10px] text-slate-900 tabular-nums shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
          }
        >
          {expanded && <Eye className="size-3" aria-hidden />}
          {display}
        </Link>
      </TooltipTrigger>
      <TooltipContent side="right">{label}</TooltipContent>
    </Tooltip>
  );
}
